import React from 'react';
import { Link } from 'react-router-dom';
import { PRACTICE_INFO } from '../../data/navigation';
import s from './Topbar.module.css';

export default function Topbar({ hidden }) {
  return (
    <div className={`${s.topbar} ${hidden ? s.topbarHidden : ''}`}>
      <div className="container">
        <div className={s.left}>
          <span className={s.item}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
            {PRACTICE_INFO.fullAddress}
          </span>
          <a href={`tel:${PRACTICE_INFO.phoneRaw}`} className={s.item}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.63A2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
            {PRACTICE_INFO.phone}
          </a>
        </div>
        <Link to="/book-appointment" className={s.cta}>Request Appointment</Link>
      </div>
    </div>
  );
}
